export default {
  init() {
    // JavaScript to be fired on the about us page
  },
  finalize() {
    let map = new google.maps.Map(document.getElementById('interactive-map'), {
      center: {
        lat: window.branchLocations[0].lat,
        lng: window.branchLocations[0].lng,
      },
      zoom: 13,
      disableDefaultUI: true,
      mapTypeControl: false,
      styles: [
        {
          elementType: 'geometry',
          stylers: [
            {
              color: '#f5f5f5',
            },
          ],
        },
        {
          elementType: 'labels',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
        {
          elementType: 'labels.icon',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
        {
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#616161',
            },
          ],
        },
        {
          elementType: 'labels.text.stroke',
          stylers: [
            {
              color: '#f5f5f5',
            },
          ],
        },
        {
          featureType: 'administrative.land_parcel',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
        {
          featureType: 'administrative.land_parcel',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#bdbdbd',
            },
          ],
        },
        {
          featureType: 'administrative.neighborhood',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
        {
          featureType: 'poi',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
        {
          featureType: 'road',
          stylers: [
            {
              color: '#addbd6',
            },
          ],
        },
      ],
    });

    window.branchLocations.forEach(item => {
      new google.maps.Marker({
        position: item,
        icon: {
          size: new google.maps.Size(48, 49),
          origin: new google.maps.Point(0, 0),
          anchor: new google.maps.Point(24, 24),
          url: 'data:image/png;base64,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',
        },
        map: map,
      })
    });

    $('.accordion-button').on('click', e => {
      if (!$(e.currentTarget).hasClass('collapsed')) {
        const locToHash = $(e.currentTarget).text().trim().toLowerCase().replace(/ /g, '-');
        if (window.history) {
          window.history.pushState(null, `${window.document.title} - ${$(e.currentTarget).text()}`, `#${locToHash}`)
        } else {
          window.location.hash = `#${locToHash}`;
        }

        const i = $(e.currentTarget).data('item-id') - 1;
        map.panTo({
          lat: window.branchLocations[i].lat,
          lng: window.branchLocations[i].lng,
        });
      }
    });

    /** open branch on hash */
    if (window.location.hash) {
      $('.accordion-button').each((index) => {
        const $item = $('.accordion-button').eq(index);
        if ($item.first().text().trim().toLowerCase().replace(/ /g, '-') === window.location.hash.substring(1)) {
          if ($item.attr('aria-expanded') !== 'true') {
            $item.trigger('click');
            map.panTo({
              lat: window.branchLocations[index].lat,
              lng: window.branchLocations[index].lng,
            });
          }
        }
      });
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/contact.js